import { render, staticRenderFns } from "./savedDashboards.vue?vue&type=template&id=4aa920c6"
import script from "./savedDashboards.vue?vue&type=script&lang=js"
export * from "./savedDashboards.vue?vue&type=script&lang=js"
import style0 from "./savedDashboards.vue?vue&type=style&index=0&id=4aa920c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports